import React from 'react';
import {Button} from '@deviceinsight/ng-ui-basic-components';

import iconShare from '../../../assets/icon_chain.svg';

type Props = {
	onClick: () => any;
};

const ShareButton = ({onClick}: Props) => (
	<Button
		naked
		title={{
			id: 'assets.detail.conditionMonitoring.shareButtonLabel',
			defaultValue: 'Share'
		}}
		onClick={onClick}>
		<img src={iconShare} alt="" />
	</Button>
);

export default ShareButton;
